<ng-container>
    <div class="row" [ngBusy]="{
    busy: busySave,
    message: 'Veuillez patienter ...',
    backdrop: false
  }">

        <div class="col-12 mb-3" *ngIf="idPatient">
            <fieldset class="custom-fieldset">
                <legend>Infos patient</legend>

                <div class="col-12">
                    <app-info-patient-consultation [idPatient]="idPatient"></app-info-patient-consultation>
                </div>
            </fieldset>
        </div>

        <div class="col-12 mb-3">
            <fieldset class="custom-fieldset">
                <legend>Identification non conformité</legend>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label>N° Non Conformité : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="N° Non conformité" autocomplete="off"
                            [(ngModel)]="itemToSave.code" disabled name="nConformite" type="text">
                    </div>

                    <div class="col-md-4">
                        <label>Date et heure : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="N° Date et heure" autocomplete="off"
                            [(ngModel)]="itemToSave.createdAt" disabled name="nConformite" type="text">
                    </div>

                     <div class="col-md-4">
                        <label>Domaine d'activité : <span class="required_champs">*</span></label>
                        <ng-select [(ngModel)]="itemToSave.domaineActiviteId" placeholder="Choisissez"  [disabled]="itemToSave?.isReadOnly" 
                            name="domaineActiviteId" id="domaineId" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of listDomainesActivites" [value]="item.id">
                                {{item?.libelle}}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- <div class="col-md-4">
                        <label>Structure : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="Structure provénance" autocomplete="off"
                            [(ngModel)]="itemToSave.structureProvenance" [disabled]="itemToSave?.isReadOnly" name="structureProvenance" type="text">
                    </div> -->

                </div>

                <div class="row mt-3">

                    <!-- <div class="col-md-4">
                        <label>Service de provenance : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="Service" autocomplete="off"
                            [(ngModel)]="itemToSave.serviceProvenance"  [disabled]="itemToSave?.isReadOnly" name="serviceProvenance" type="text">
                    </div>

                    <div class="col-md-4">
                        <label>Unité : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="Unité" autocomplete="off"
                            [(ngModel)]="itemToSave.unite" name="unite"  [disabled]="itemToSave?.isReadOnly" type="text">
                    </div> -->

                   


                    <!-- <div class="col-md-6">
                        <label>Domaine d'activité : <span class="required_champs">*</span></label>
                        <input class="form-control custom-input" placeholder="N° Dossier" autocomplete="off"
                            [(ngModel)]="itemToSave.numeroDossier" name="nConformite" type="text">
                    </div> -->


                </div>

            </fieldset>

        </div>

        <div class="col-12 mb-3">
            <fieldset class="custom-fieldset">
                <legend>Non conformité</legend>

                <div class="row mb-3">

                    <div class="col-md-3">
                        <label>Support : <span class="required_champs">*</span></label>
                        <ng-select [(ngModel)]="itemToSave.supportId" placeholder="Choisissez"
                            (change)="getParametreNC(itemToSave.supportId)" name="supportId" id="emploiId"  [disabled]="itemToSave?.isReadOnly" 
                            [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of listSupports" [value]="item.id">
                                {{item?.libelle}}
                            </ng-option>
                        </ng-select>
                    </div>

                    <div class="col-md-3">
                        <label>Paramètres NC : <span class="required_champs">*</span></label>
                        <ng-select [(ngModel)]="itemToSave.paramId" placeholder="Choisissez" name="paramId" id="paramId"  [disabled]="itemToSave?.isReadOnly" 
                            [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of listParametreNonConformite" [value]="item.id">
                                {{item?.libelle}}
                            </ng-option>
                        </ng-select>
                    </div>

                    <div class="col-md-3">
                        <label>Actions Recommandées : <span class="required_champs">*</span></label>
                        <ng-select [(ngModel)]="itemToSave.actionId" placeholder="Choisissez" name="actionId"  [disabled]="itemToSave?.isReadOnly" 
                            id="actionId" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of listActionRecommandees" [value]="item.id">
                                {{item?.libelle}}
                            </ng-option>
                        </ng-select>
                    </div>


                    <div class="col-md-2">
                        <button class="btn btn-xs btn-default btn-add" type="button" (click)="addNonConformite()"  [disabled]="itemToSave?.isReadOnly" >
                            Ajouter </button>
                    </div>


                </div>

                <div class="row mt-3">
                    <div class="col-12">
                        <table class="table table-condensed table-striped">
                            <thead>
                                <tr class="custom-table-head">
                                    <th>#</th>
                                    <!-- <th>Support</th> -->
                                    <th>Paramètre NC</th>
                                    <th>Actions Recommandées</th>
                                    <th style="width: 25px;"></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of listeNonConformites; let indice = index">
                                    <td>{{indice+1}}</td>
                                    <!-- <td>{{item?.supportLibelle}}</td> -->
                                    <td>{{item?.paramLibelle || item?.ncParamLibelle}}</td>
                                    <td>{{item?.actionLibelle || item?.ncActionRecomLibelle}}</td>
                                    <td>
                                        <a title="Supprimer non conformité" (click)="deleteNonConformite(indice)"*ngIf=!itemToSave?.isReadOnly
                                            style="color: red;">
                                            <i class="fa fa-trash"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>



            </fieldset>

        </div>


        <div class="col-12 mb-3">
            <fieldset class="custom-fieldset">
                <legend>Info complémentaire</legend>

                <div class="row">
                    <div class="col-md-6">
                        <label>Observation : </label>
                        <textarea rows="2" class="form-control custom-input" name="description"
                            [(ngModel)]="itemToSave.description"  [disabled]="itemToSave?.isReadOnly" >
                        </textarea>
                    </div>

                    <div class="col-md-6">
                        <label>Actions immédiates : </label>
                        <textarea rows="2" class="form-control custom-input" name="actionImmediate"
                            [(ngModel)]="itemToSave.actionImmediate"  [disabled]="itemToSave?.isReadOnly" >
                        </textarea>
                    </div>
                </div>

            </fieldset>
        </div>

        <div class=" btn-manger-part">

            <button type="button" class="btn btn-md btn-cancel pull-right" (click)="handleClose(false)">
                Fermer
            </button>

            <button type="button" class="btn btn-md custom_btn_primary pull-right" (click)="confirmSaveItem()">
               {{canUpdate ? 'Modifier' : 'Enregistrer' }} 
            </button>&nbsp;&nbsp;

        </div>

    </div>


</ng-container>